import { render, staticRenderFns } from "./FormMobileTidakTercatatReadonly.vue?vue&type=template&id=f105dae4&"
import script from "./FormMobileTidakTercatatReadonly.vue?vue&type=script&lang=js&"
export * from "./FormMobileTidakTercatatReadonly.vue?vue&type=script&lang=js&"
import style0 from "./FormMobileTidakTercatatReadonly.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports